"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DotNavigationDataKeys;
(function (DotNavigationDataKeys) {
    DotNavigationDataKeys["ShowBorder"] = "data-show-border";
    DotNavigationDataKeys["Theme"] = "data-theme";
    DotNavigationDataKeys["SavedCurrentIndex"] = "data-current";
})(DotNavigationDataKeys = exports.DotNavigationDataKeys || (exports.DotNavigationDataKeys = {}));
var DotNavigationDataHooks;
(function (DotNavigationDataHooks) {
    DotNavigationDataHooks["Dot"] = "dot";
})(DotNavigationDataHooks = exports.DotNavigationDataHooks || (exports.DotNavigationDataHooks = {}));
//# sourceMappingURL=dataHooks.js.map